import { Component, inject } from '@angular/core';
import { SiaNewRouterService, SiaUsersService } from '@sia/shared';
import { SiaGridConfigComponent } from '../../components/sia-grid-config/sia-grid-config.component';

@Component({
  selector: 'sia-grid-config-page',
  template: ` <sia-grid-config></sia-grid-config> `,
  styles: [],
  standalone: true,
  imports: [SiaGridConfigComponent],
})
export class SiaGridConfigPageComponent {
  private routerService = inject(SiaNewRouterService);
  private usersService = inject(SiaUsersService);

  /** Inserted by Angular inject() migration for backwards compatibility */

  constructor() {
    this.checkAdminPermission();
  }

  private checkAdminPermission() {
    var user = this.usersService.getUserData();
    var authorized = user && user.isAdmin;
    if (!authorized) {
      this.routerService.navigateTo404();
    }
  }
}
